import { updateNextMeetingInformation } from '../actions/internalActions';
import getTimeToNextMeeting from '../selectors/getTimeToNextMeeting';
import store from '../store/store';
import { mutator } from 'satcheljs';
import CalendarItem from 'owa-service/lib/contract/CalendarItem';
import NextMeetingInformation from '../store/schema/NextMeetingInformation';

export default mutator(updateNextMeetingInformation, actionMessage => {
    if (!actionMessage.nextMeeting) {
        store.nextMeetingInformation = null;
    } else {
        store.nextMeetingInformation = <NextMeetingInformation>{
            name: actionMessage.nextMeeting.Subject,
            location: actionMessage.nextMeeting.Location.DisplayName,
            time: actionMessage.nextMeeting.Start,
            timeUntilMeeting: getTimeToNextMeeting(actionMessage.nextMeeting),
        };
    }
});

export { CalendarItem };
